export enum DialogActionsAlign {
  start = "start",
  end = "end",
  spaceBetween = "space-between",
}

export enum DialogSize {
  small = "small",
  normal = "normal",
  large = "large",
  xlarge = "xlarge",
  xxlarge = "xxlarge",
}
